import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import { Grid,Container, Box ,Autocomplete } from "@mui/material";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import "../Style/InvoiceForm.css";
import "../Style/Common.css";
import "../Style/AddCustomerPopup.css";
import { getOrganizationDetails } from "../Services/orgService";
import Swal from "sweetalert2";
import { generatePerformaInvoicePDF, getStateCode, indianStates } from "../Services/CommonService";

import {
  createInvoice,
  getPerformaInvoicesNumber,
} from "../Services/InvoicePageService";
import Footer from "../Footer/Footer";
import Select from "react-select";
import { convertINRToWords } from "../Services/CommonService";
import { getItems } from "../Services/inventoryService";
import { IInvoiceData, IInvoiceFormData, InvoiceItem, IPerformaInvoice } from "../Interfaces/IInvoice";
import TextField from "@mui/material/TextField/TextField";

// declare module "jspdf" {
//   interface jsPDF {
//     lastAutoTable?: {
//       finalY: number; // Position of the last row in the previous table
//     };
//   }
// }

const PerformaInvoice: React.FC = () => {
  const [items, setItems] = useState<
    {
      value: string;
      label: string;
      price: number;
      discount: number;
      tax: number;
      hsn: string;
    }[]
  >([]); // Dropdown options
  // const [selectedItem, setSelectedItem] = useState<ItemOption | null>(null);
  const [buyerStateCode, setBuyerStateCode] = useState<string>("");
  const [includeShipping, setIncludeShipping] = useState(false);
  const [shippingCharge, setShippingCharge] = useState<number>(0);
  const [invoiceItems, setInvoiceItems] = useState<InvoiceItem[]>([
    {
      itemId: "",
      description: "",
      quantity: 1,
      rate: 1,
      discount: 0,
      tax: 0,
      amount: 0,
      hsn: "",
    },
  ]);
  const [selectedCustomer, setSelectedCustomer] = useState<{
    city: any;
    state: any;
    country: any;
    zipCode: any;
    phone: any;
    GSTIN: any;
    street: any;
    email: any;
    id: string;
    name: string;
  } | null>(null);
  //const [selectedSalesperson, setSelectedSalesperson] = useState<string>("");
  const [orgDetails, setOrgDetails] = useState<any>(null); //Need to update org interface
  const orgId = localStorage.getItem("orgId") ?? "";
  const fetchInvoiceNumber = async () => {
    try {
      const latestInvoiceNumber = await getPerformaInvoicesNumber(orgId);
      setFormData((prev: any) => ({
        ...prev,
        invoiceNumber: latestInvoiceNumber,
      }));
      //Get Org details
      const orgData = await getOrganizationDetails(orgId);
      setOrgDetails(orgData);
    } catch (error) {
      console.error("Failed to fetch the latest invoice number", error);
    }
  };
  const [itemsKey, setItemsKey] = useState(0);
  const loadItems = async () => {
    try {
      const itemData = await getItems(orgId); // Fetch items from API
      const formattedItems = itemData.map((item: any) => ({
        value: item.itemId,
        label: `${item.name} - ${item.desc || "No description"}`, // Combine name and description
        price: item.sellingPrice,
        discount: 0, //bind letter,
        tax: 0,
        hsn: item.hsn,
      }));
      setItems(formattedItems); 
      setItemsKey((prev) => prev + 1); 
    } catch (error) {
      console.error("Error loading items:", error);
      alert("Failed to load items. Please try again.");
    }
  };
  useEffect(() => {
    loadItems();
    fetchInvoiceNumber();
  }, []);

 const [formData, setFormData] = useState<IPerformaInvoice>({
    customerName: "",
    invoiceNumber: "",
    orderNumber: "",
    invoiceDate: new Date().toISOString(),
    terms: "",
    dueDate: new Date().toISOString(),
    salesPerson: "",
    contactNumber: "",
    paymentMode: "",
    buyerOrderDate: "",
    customerState:"",
  });
  const handleAddNewItem = () => {
    setInvoiceItems([
      ...invoiceItems,
      {
        itemId: "",
        description: "",
        quantity: 1,
        rate: 1,
        discount: 0,
        tax: 0,
        amount: 0,
        hsn: "",
      },
    ]);
  };
  const handleRemoveItem = (index: number) => {
    const updatedItems = [...invoiceItems];
    updatedItems.splice(index, 1);
    setInvoiceItems(updatedItems);
  };
  const handleItemChange = (index: number, name: string, value: any) => {
    const updatedItems = [...invoiceItems];
    updatedItems[index] = { ...updatedItems[index], [name]: value };
    setInvoiceItems(updatedItems);
  };
  const handleGeneratePDF = async () => {
    if (!formData.customerName) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Customer Name is required.",
      });
      return;
    }
    if (!formData.customerState?.trim()) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Customer State is required.",
      });
      return;
    }
    // Validate item rate and quantity
    for (const item of invoiceItems) {
      if (item.rate <= 0) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Rate",
          text: "Rate cannot be negative.",
        });
        return;
      }

      if (item.quantity <= 0) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Quantity",
          text: "Quantity must be greater than zero.",
        });
        return;
      }
    }
    if (invoiceItems.length === 0 || invoiceItems[0].description === "") {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please add at least one item to the invoice.",
      });
      return;
    }

    const invoiceData: IInvoiceData = {
      orgId: orgId,
      invoiceId: formData.invoiceNumber,
      customerId: selectedCustomer?.id ?? "",
      orderId: formData.orderNumber || "N/A",
      orderDate: "",
      invoiceDate: new Date(formData.invoiceDate).toISOString(),
      customerName: formData?.customerName ?? "N/A",
      totalTax: totalGST,
      totalDiscount: discTotal,
      subTotalAmount: subTotal,
      shippingCharge: includeShipping ? shippingCharge : 0,
      grandTotal: total,
      buyerStateCode: buyerStateCode, //buyerStateCode,
      sellerStateCode: sellerStateCode, //sellerStateCode,
      isIntraState: isIntraState, //isIntraState,
      totalCGST: totalCGST, //totalCGST,
      totalSGST: totalSGST, //totalSGST,
      buyerGST:orgDetails?.GST, //selectedCustomerById.GSTIN || "",
      sellerGST: "", //orgDetails?.GST || "",
      status: "",
      invoiceType: "PerformaInvoice",
      createdBy: "AdminUser", // Replace with the current user
      createdIp: "", // Replace with actual IP address
      salesPersonId: "", // Add this property
      dueDate: new Date().toISOString(), // Add this property
      salesPersonName: "", // Add this property
      terms: "", // Add this property
      phone: formData?.contactNumber || "",
      paymentMode: "",
      totalPaidAmount: 0,
      itemDetails: invoiceItems.map((item, index) => ({
        itemId: item.itemId,
        itemDesc: item.description,
        qty: item.quantity,
        price: item.rate,
        discount: item.discount,
        Tax: item.tax,
        hsn: item.hsn,
        amount: parseFloat(
          (
            item.quantity *
            item.rate *
            (1 - item.discount / 100) *
            (1 + item.tax / 100)
          ).toFixed(2)
        ),
        taxType: "GST", // Replace with dynamic value if applicable
      })),
    };
    try {
      const saveResponse = await createInvoice(invoiceData);
      Swal.fire({
        title: "Success!",
        text: saveResponse.message,
        icon: "success",
        confirmButtonText: "Ok",
      });
      // const invoiceDate = new Date(formData.invoiceDate);
      // const formattedInvoiceDate = invoiceDate.toLocaleDateString("en-GB");
      // Step 3: Generate PDF if Save is Successful
        generatePerformaInvoicePDF(
          orgDetails,
          formData,
          invoiceItems,
          subTotal,
          totalCGST,
          totalSGST,
          totalGST,
          discTotal,
          false, // includeShipping if needed
          0,
          total,
          isIntraState,
          buyerStateCode,
          sellerStateCode,
          taxSummary
        );
      /*
      // Logic for PDF generation here
      const doc = new jsPDF();
      // Header with background color
      doc.setFillColor(41, 128, 185); // Blue background
      doc.rect(0, 0, 210, 30, "F");
      doc.setTextColor(255, 255, 255); // White text
      doc.setFontSize(16);
      doc.text(`${orgDetails?.OrgName || "N/A"}`, 40, 20);
      try {
        const base64Image: string = await getBase64FromImageUrl(
          orgDetails.logo
        );
        if (!base64Image.startsWith("data:image/png;base64,")) {
          throw new Error("Fetched Base64 data is not valid for a PNG image.");
        }
        doc.addImage(base64Image, "PNG", 15, 10, 22, 20);
      } catch (error) {
        console.error("Error adding image to PDF:", error);
      }
      // Invoice Details (Right Side)
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(11);
      doc.text(`Performa Invoice`, 82, 8);
      doc.text(`Performa Number:${formData.invoiceNumber}`, 150, 10);
      doc.text(`Performa Date:${formattedInvoiceDate}`, 150, 15);
      doc.setFontSize(12);
      doc.text("Billing From:", 15, 40);
      doc.text(`${orgDetails?.OrgName || "N/A"}`, 15, 45);
      doc.text(`Email:${orgDetails?.email || "N/A"}`, 15, 50);
      doc.text(
        `Address: ${orgDetails?.address[0]?.addressLine1},${orgDetails?.address[0]?.addressLine2},${orgDetails?.address[0]?.city},\n${orgDetails?.address[0]?.state},${orgDetails?.address[0]?.zipCode}`,
        15,
        55
      );
      doc.text(`Contact Number: ${orgDetails?.phone || "N/A"}`, 15, 65);
      doc.text(`GSTIN: ${orgDetails?.GST || "N/A"}`, 15, 70);
      // Add "Billing To" section
      doc.text("Billing To:", 125, 40);
      doc.text(`${formData?.customerName}`, 125, 45); // Replace with actual customer info
      doc.text(`Phone:${formData?.contactNumber}`, 125, 50);
      //doc.text(`GSTIN:${selectedCustomer?.GSTIN}`, 125, 70);
      // Table Header and Content
      const tableColumn = [
        { header: "Sn", dataKey: "sn" },
        { header: "Description", dataKey: "description" },
        { header: "HSN", dataKey: "hsn" },
        { header: "Rate", dataKey: "rate" },
        { header: "Quantity", dataKey: "quantity" },
        { header: "Discount %", dataKey: "discount" },
        { header: "Tax %", dataKey: "tax" },
        { header: "Amount", dataKey: "amount" },
      ];
      const tableRows = invoiceItems.map((item, index) => ({
        sn: index + 1,
        description: item.description,
        hsn: item.hsn,
        rate: item.rate,
        quantity: item.quantity,
        discount: item.discount,
        tax: item.tax,
        amount: (
          item.quantity *
          item.rate *
          (1 - item.discount / 100) *
          (1 + item.tax / 100)
        ).toFixed(2),
      }));
      // Generate Table
      autoTable(doc, {
        columns: tableColumn,
        body: tableRows,
        startY: 75, // Start Y position
        theme: "grid",
        headStyles: { fillColor: [41, 128, 185] },
      });
      // Dynamically calculate the next position after the table
      const finalY = (doc as any).lastAutoTable.finalY || 80;
      // Add a safe margin after the table to avoid overlap
      const marginAfterTable = 10;
      // Bank Details (Left Side)
      let yOffset = finalY + marginAfterTable;
      // Bank Details (Left Side)
      doc.setFontSize(10);
      doc.text("Payment Instructions:", 14, yOffset);
      doc.text(
        `A/c Holder Name: ${
          orgDetails?.accountDetails[0]?.accountHolderName || "N/A"
        }`,
        14,
        yOffset + 5
      );
      doc.text(
        `Account No.: ${orgDetails?.accountDetails[0]?.accountNumber || "N/A"}`,
        14,
        yOffset + 10
      );
      doc.text(
        `IFSC: ${orgDetails?.accountDetails[0]?.ifscCode || "N/A"}`,
        14,
        yOffset + 15
      );
      doc.text(
        `Bank Name: ${orgDetails?.accountDetails[0]?.bankName || "N/A"}`,
        14,
        yOffset + 20
      );
      // Summary Details (Right Side)
      yOffset = finalY + marginAfterTable; // Reset yOffset to align both sections
      const summaryX = 140;
      doc.text(`Subtotal: ${subTotal.toFixed(2)}`, summaryX, yOffset);
      doc.text(`IGST: ${totalGST.toFixed(2)}`, summaryX, yOffset + 5);
      doc.text(
        `Shipping Charge: ${includeShipping ? shippingCharge.toFixed(2) : 0}`,
        summaryX,
        yOffset + 10
      );
      doc.text(
        `Total: ${total.toFixed(2)}`,
        summaryX,
        yOffset + 15
      );
      const pageHeight = doc.internal.pageSize.height;
      doc.setFontSize(10);
      doc.setTextColor(100);
      const pageWidth = doc.internal.pageSize.width; // A4 width
      const marginLeft = 15;
      const maxWidth = pageWidth - 30; // Adjusting for left & right margins
      const termsText = `Term and conditions-${
        orgDetails?.termAndCondition ?? ""
      }`;
      // Auto-wrap text within the defined width
      const wrappedText = doc.splitTextToSize(termsText, maxWidth);
      // Calculate Y position dynamically (e.g., 12mm from the bottom)
      const termsY = pageHeight - 10 - wrappedText.length * 4; // Adjust based on line count
      doc.text(
        `Amount in words- ${convertINRToWords(Number(total.toFixed(2)))}.`,
        15,
        termsY - 8
      );

      // Add text to the PDF
      doc.text(wrappedText, marginLeft, termsY);
      // Save PDF
      doc.save(`PerformaInvoice_${formData.invoiceNumber}.pdf`);
     */
      // Refresh the invoice number and items
      setFormData((prev) => ({
        ...prev,
        customerName: "",
        invoiceNumber: "",
        orderNumber: "",
        invoiceDate: new Date().toISOString().split("T")[0],
        terms: "",
        dueDate: new Date().toISOString().split("T")[0],
        salesPerson: "",
        contactNumber: "",
      }));

      await fetchInvoiceNumber();
      // Clear the selected items and reset form
      setInvoiceItems([
        {
          itemId: "",
          description: "",
          quantity: 1,
          rate: 1,
          discount: 0,
          tax: 0,
          amount: 1,
          hsn: "",
        },
      ]);
      await loadItems();
      setShippingCharge(0);
      setSelectedCustomer(null);
    } catch (error: any) {
      alert(`Failed to save invoice: ${error.message}`);
    }
    // End Logic for PDF generation here
  };
  const sellerStateCode =
  orgDetails?.GST?.substring(0, 2) ||
  getStateCode(orgDetails?.address[0]?.state);
  
  const isIntraState = buyerStateCode === sellerStateCode;
  // Calculate Subtotal
  const subTotal = invoiceItems.reduce(
    (acc, item) => acc + item.quantity * item.rate,
    0
  );
  // Calculate Total GST
  // const totalGST = invoiceItems.reduce(
  //   (acc, item) => acc + (item.quantity * item.rate * item.tax) / 100,
  //   0
        // );
        const totalGST = invoiceItems.reduce((acc, item) => {
        const qty = Number(item.quantity);
        const rate = Number(item.rate);
        const discount = Number(item.discount);
        const tax = Number(item.tax);

        const discountedAmount = qty * rate * (1 - discount / 100);
        const gstAmount = (discountedAmount * tax) / 100;

        return acc + gstAmount;
      }, 0);

      let totalCGST = 0;
      let totalSGST = 0;

      if (isIntraState) {
        totalCGST = totalGST / 2;
        totalSGST = totalGST / 2;
      }
    const discTotal = invoiceItems.reduce(
      (acc, item) =>
        acc + (item.quantity * item.rate * item.discount) / 100,
      0
    );

  // Calculate Total (Including GST and Shipping Charge)
  // const total =
  //   invoiceItems.reduce((acc, item) => {
  //     const itemTotal =
  //       item.quantity *
  //       item.rate *
  //       (1 - item.discount / 100) *
  //       (1 + item.tax / 100);
  //     return acc + itemTotal;
  //   }, 0) + (includeShipping ? shippingCharge : 0); // Add Shipping Charge if enabled
        const total =
        invoiceItems.reduce((acc, item) => {
          const qty = Number(item.quantity);
          const rate = Number(item.rate);
          const discount = Number(item.discount);
          const tax = Number(item.tax);

          const itemTotal =
            qty * rate * (1 - discount / 100) * (1 + tax / 100);

          return acc + itemTotal;
        }, 0) + (includeShipping ? shippingCharge : 0);
        type TaxSlab = "3" | "5" | "12" | "18" | "28";

        const taxSummary: Record<TaxSlab, number> = {
          "3": 0,
          "5": 0,
          "12": 0,
          "18": 0,
          "28": 0,
        };

        invoiceItems.forEach((item) => {
          const taxRate = item.tax.toString() as TaxSlab;

          const taxableAmount =
            item.quantity *
            item.rate *
            (1 - item.discount / 100);

          const gstAmount = (taxableAmount * item.tax) / 100;

          if (taxSummary[taxRate] !== undefined) {
            taxSummary[taxRate] += gstAmount;
          }
        });
  //Paid amount check
  // State to track whether the invoice is marked as paid
  const [isPaid, setIsPaid] = useState(true); // Default checkbox state is checked

  /**
   * Handles the change event for the 'Paid' checkbox.
   * Updates the 'isPaid' state and resets the 'paidAmount' to 0 if unchecked.
   *
   * @param e - The change event from the checkbox input
   */
  const handlePaidChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsPaid(e.target.checked);
    if (!e.target.checked) {
      setPaidAmount(""); // Reset paid amount if unchecked
    }
  };

  const [paidAmount, setPaidAmount] = useState<number | string>("");

  return (
    <>
      {/* Location text added directly */}
      <div className="page-location">
        <span>Sales &gt; Performa Invoice</span>
      </div>
      <Container maxWidth="lg" sx={{ padding: 1 }}>
        
        {/* <form className="invoice-form">
          <div className="form-group">
            <TextField
              label="Customer Name"
              variant="outlined"
              name="customerName"
              value={formData.customerName}
              className="input-item-name"
              required
              onChange={(e) => {
                const regex = /^[a-zA-Z0-9\s.,_]+$/
                if (!regex.test(e.target.value)) {
                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Please enter valid customer name",
                  });
                  setFormData({ ...formData, customerName: "" });
                } else {
                  setFormData({ ...formData, customerName: e.target.value });
                }
              }}
            />
          </div>
          <div className="form-group">
            <TextField
              label="Contact Number"
              variant="outlined"
              name="contactNumber"
              value={formData.contactNumber}
              className="input-item-name"
              onChange={(e) => {
                //const regex = /^[6-9]\d{9}$/;
                //corrected by Gaurav
                const regex = /^[+0-9]+$/;
                if (!regex.test(e.target.value)) {
                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Please enter valid contact number",
                  });
                  setFormData({ ...formData, contactNumber: "" });
                } else {
                  setFormData({ ...formData, contactNumber: e.target.value });
                }
              }}
            />
          </div>
          <div className="form-group">
          <label>
            Customer State <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            options={indianStates}
            value={indianStates.find(
              (state) => state.value === buyerStateCode
            )}
            onChange={(selectedOption) => {
              setBuyerStateCode(selectedOption?.value || "");

              setFormData((prev) => ({
                ...prev,
                customerState: selectedOption?.label || "",
              }));
            }}
            placeholder="Select State"
            isSearchable
          />
          </div>
        </form> */}
        <form className="invoice-form">
  <Grid container spacing={2}>
    
    {/* Customer Name - Full width always */}
    <Grid item xs={12}>
      <TextField
        label="Customer Name"
        variant="outlined"
        fullWidth
        name="customerName"
        value={formData.customerName}
        required
        onChange={(e) => {
          const value = e.target.value;
          const regex = /^[a-zA-Z0-9\s.,_&()\-'/]+$/;

          if (value === "" || regex.test(value)) {
            setFormData((prev) => ({
              ...prev,
              customerName: value,
            }));
          }
        }}
      />
    </Grid>

    {/* Contact Number */}
    <Grid item xs={12} sm={6}>
      <TextField
        label="Contact Number"
        variant="outlined"
        fullWidth
        name="contactNumber"
        value={formData.contactNumber}
        onChange={(e) => {
          const value = e.target.value;
          const regex = /^[+0-9]*$/;

          if (regex.test(value)) {
            setFormData((prev) => ({
              ...prev,
              contactNumber: value,
            }));
          }
        }}
      />
    </Grid>

    {/* Customer State */}
    <Grid item xs={12} sm={6}>
      <Autocomplete
      options={indianStates}
      getOptionLabel={(option) => option.label}
      value={
        indianStates.find(
          (state) => state.value === buyerStateCode
        ) || null
      }
      onChange={(event, newValue) => {
        setBuyerStateCode(newValue?.value || "");

        setFormData((prev) => ({
          ...prev,
          customerState: newValue?.label || "",
        }));
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Customer State"
          required
        />
      )}
    />
    </Grid>
  </Grid>
</form>

        {/* Item Details Container */}
        <div className="invoice-items-container">
          <h3 className="section-title">Item Details</h3>
          {invoiceItems.map((item, index) => (
            <div key={index} className="item-row">
              <div className="item-fields">
                <label>
                  Item Name:
                  <Select
                    className="input-hsn"
                    key={itemsKey} // ✅ Forces re-render
                    options={items} // Assuming `items` is an array of options
                    value={items.find(
                      (option: { value: any }) =>
                        option.value === invoiceItems[index].itemId
                    )} // Match the value with the `itemId`
                    onChange={(selectedOption) => {
                      // Get the selected item's details from `items`
                      const selectedItem = items.find(
                        (item: { value: string }) =>
                          item.value === selectedOption?.value
                      );

                      if (selectedItem) {
                        // Update the specific item in the `invoiceItems` array
                        const updatedItems = [...invoiceItems];
                        updatedItems[index] = {
                          ...updatedItems[index],
                          description: selectedItem.label, // Use the label for the description
                          itemId: selectedItem.value, // Update the itemId
                          rate: selectedItem.price || 0, // Bind the price to `rate`
                          discount: selectedItem.discount || 0, // Bind the discount
                          tax: selectedItem.tax || 0, //bind the tax
                          hsn:selectedItem.hsn || "",
                        };
                        setInvoiceItems(updatedItems); // Update the state
                      }
                    }}
                    placeholder="Select Item"
                    isSearchable
                    styles={{
                      container: (base) => ({
                        ...base,
                        width: "350px",
                      }),
                    }}
                  />
                </label>
                <label>
                  HSN:
                  <input
                    type="text"
                    placeholder="HSN"
                    className="item-input"
                    value={item.hsn}
                    onChange={(e) => {
                      handleItemChange(index, "hsn", e.target.value);
                    }}
                  />
                </label>
                <label>
                  Quantity:
                  <input
                    type="number"
                    placeholder="Quantity"
                    className="item-input"
                    value={item.quantity}
                    onChange={(e) => {
                      const value = Number(e.target.value);
                      if (value <= 0) {
                        Swal.fire({
                          icon: "warning",
                          title: "Invalid Quantity",
                          text: "Quantity must be greater than zero.",
                        });
                        return;
                      }
                      handleItemChange(index, "quantity", value);
                    }}
                  />
                </label>
                <label>
                  Rate:
                  <input
                    type="number"
                    placeholder="Rate"
                    className="item-input"
                    value={item.rate}
                    onChange={(e) => {
                      const value = Number(e.target.value);
                      if (value <= 0) {
                        Swal.fire({
                          icon: "warning",
                          title: "Invalid Rate",
                          text: "Rate must be greater than zero.",
                        });
                      } else {
                        handleItemChange(index, "rate", value);
                      }
                    }}
                  />
                </label>
                <label>
                  Discount:
                  <select
                    className="item-input"
                    value={item.discount}
                   onChange={(e) =>
                      handleItemChange(index, "discount", Number(e.target.value))
                    }
                  >
                    <option value="0">No Discount</option>
                    <option value="10">10%</option>
                    <option value="20">20%</option>
                  </select>
                </label>
                <label>
                  Tax:
                  <select
                    className="item-input"
                    value={item.tax}
                   onChange={(e) =>
                    handleItemChange(index, "tax", Number(e.target.value))
                  }
                  >
                    <option value="0">Tax Not Applicable</option>
                    <option value="3">3%</option>
                    <option value="5">5%</option>
                    <option value="12">12%</option>
                    <option value="18">18%</option>
                    <option value="28">28%</option>
                  </select>
                </label>
                <label>
                  Tax Amount:
                  <input
                    type="text"
                    className="item-input"
                    value={
                      item.quantity && item.rate
                        ? (
                            item.quantity *
                            item.rate *
                            (1 - item.discount / 100) *
                            (item.tax / 100)
                          ).toFixed(2)
                        : "0.00"
                    }
                    readOnly
                  />
                </label>
                <label>
                  Total:
                  <input
                    type="text"
                    className="item-input"
                    value={(
                      item.quantity *
                      item.rate *
                      (1 - item.discount / 100) * // Apply discount
                      (1 + item.tax / 100)
                    ) // Apply tax
                      .toFixed(2)}
                    readOnly
                  />
                </label>
              </div>
              <img
                src="/icons8-delete-94.png"
                alt="Remove"
                className="remove-button"
                onClick={() => handleRemoveItem(index)}
              />
            </div>
          ))}
          <button
            type="button"
            className="add-item-button"
            onClick={handleAddNewItem}
          >
            + Add New Item
          </button>
          <div className="totalprice">
            <div className="form-subtotal">
              <label>Sub Total:</label>
              <span className="form-output">{subTotal.toFixed(2)}</span>
            </div>

            {/* <div className="form-IGST">
              <label>IGST:</label>
              <span className="form-output">{totalGST.toFixed(2)}</span>
            </div> */}
            {isIntraState ? (
            <>
              <div>
                <label>CGST:</label>
                <span>{totalCGST.toFixed(2)}</span>
              </div>
              <div>
                <label>SGST:</label>
                <span>{totalSGST.toFixed(2)}</span>
              </div>
            </>
          ) : (
            <div>
              <label>IGST:</label>
              <span>{totalGST.toFixed(2)}</span>
            </div>
          )}
            <div className="shipping-charge">
              <label className="shipping-label">
                <input
                  type="checkbox"
                  checked={includeShipping}
                  onChange={(e) => setIncludeShipping(e.target.checked)}
                />
                Include Shipping Charge
              </label>
              {includeShipping && (
                <input
                  type="number"
                  className="shipping-input"
                  placeholder="Enter Shipping Charge"
                  value={shippingCharge}
                  //onChange={(e) => setShippingCharge(Number(e.target.value))}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    if (value >= 0) {
                      setShippingCharge(value);
                    } else {
                      Swal.fire({
                        icon: "warning",
                        title: "Invalid Shipping Charge",
                        text: "Shipping charge must be greater than or equalto zero.",
                      });
                    }
                  }}
                />
              )}
            </div>

            <div className="form-total">
              <label>Total:</label>
              <span className="form-output">
                {total.toFixed(2)}
              </span>
            </div>
            <div className="form-total">
              <label>Amount in words</label>
              <label className="form-output">
                {convertINRToWords(Number(total.toFixed(2)))}
              </label>
            </div>
          </div>
          <button
            type="button"
            className="generate-button"
            onClick={handleGeneratePDF}
          >
            Save & Generate Invoice
          </button>
        </div>
      </Container>
      <Box
        sx={{
          position: "relative",
          left: 0,
          bottom: 0,
          width: "100%",
          mt: 10,
        }}
      >
        <Footer />
      </Box>
    </>
  );
};
export default PerformaInvoice;
